import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'none-widget',
  template: ``,
})
export class NoneComponent {
  @Input() layoutNode: any;
  @Input() layoutIndex: number[];
  @Input() dataIndex: number[];
}



// WEBPACK FOOTER //
// /Users/David/Sites/angular2-json-schema-form/src/lib/src/widget-library/none.component.ts